/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICoreContext,
    IGeneric
} from '@msdyn365-commerce/core';
import dayjs from 'dayjs';
import Cookies from 'universal-cookie';
import { IMFIATPInventoryEntity, IMFICartLine, IMFICLDeliveryScheduleParameters } from '../actions/CoreProductDataServiceEntities.g';
import _getDeliveryByMessage from '../Utilities/get-delivery-by-message';
// tslint:disable-next-line: completed-docs
export class CoreProductATPInfoInput implements IActionInput {
    public itemLine?: IMFICartLine;
    public ctx?: ICoreContext<IGeneric<IAny>>;
    constructor(itemLine?: IMFICartLine, ctx?: ICoreContext<IGeneric<IAny>>) {
        this.ctx = ctx;
        this.itemLine = itemLine;
    }
    public getCacheKey = () => `PLPCard${this.itemLine?.VariantRecordId?.toString()}`;
    public getCacheObjectType = () => `PLPCardIMFIATPInventoryEntity`;
    public dataCacheType = (): CacheType => 'request';
}

export async function getATPInfoForProductAction(
    input: CoreProductATPInfoInput,
    actionContext: IActionContext
): Promise<IMFIATPInventoryEntity[]> {
    let coreProductATPInfo: IMFIATPInventoryEntity[] = [];

    const cookies = new Cookies();
    const zipcode = cookies.get('zip_code');
    const date = new Date();
    const currentDate = date.setDate(date.getDate());
    const requestBody: IMFICLDeliveryScheduleParameters = {
        InventoryType: 'Delivery',
        Weeks: input.ctx!.app.config.weeksPDPforATPCall,
        StoreId: '',
        Page: 'plp',
        RequestedDate: dayjs(currentDate).format('MM/DD/YYYY'),
        ZipCode: zipcode,
        ItemLines: [input.itemLine!]
    };
    const getDeliveryByMessage = _getDeliveryByMessage(requestBody, input.ctx!);
    await getDeliveryByMessage
        .then(result => {
            if (result !== undefined && result?.ATPInventoryData && result?.ATPInventoryData.length > 0) {
                coreProductATPInfo = result?.ATPInventoryData;
                return coreProductATPInfo;
            }
            return coreProductATPInfo;
        })
        .catch(e => {
            console.log('Error', e);
        });
    return coreProductATPInfo;
}

export default createObservableDataAction({
    action: <IAction<IMFIATPInventoryEntity[]>>getATPInfoForProductAction
});
